export default function string2regex( str ) {

	const matches = str.match( /\/(.+)\/(.*)/ );

	if ( !matches ) {
		return null;
	}
	
	return new RegExp( matches[1], matches[2] );

};